module.exports = __webpack_public_path__ + "media/images/android-chrome-256x256-dc107738aed32f4369f1637d62422c5a.png";